import { Vue,Component,Emit,Prop,Watch} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import { toCamel } from 'snake-camel';
import moment from "moment";
import store from '@/assets/common/store/store';
import { LoginUser } from "@/types/Component";


@Component({
    components: {
        Modal
    }
})
export default class ProducerRegistrationModal extends Vue {
    
    screen = 'PRODUCERMASTER';
    private list: any | null = null
    private items: any = []
    private title = '生産者登録'
    private baseUrl = '/producers';
    selectScreenManagement = '/graphScreenManagement';
    private producers: any = []
    private withHidden = false
    private withProducers = true
    private withShippingOrganization = false
    private isLoading = false;
    private headerTitle!: string
    private isHidden = false
    private isDeletable = true

    //producers
    private producerId = ""
    private producerName = ""
    private producerNum = ""
    private picName = ""
    private mailAddress = ""
    private updated = ""
    private address = ""
    private teleNum = ""
    private year = ""
    private month = ""
    private date = ""
    private shippingGroupList =  [] as any[];
    private selectedShippingGroupId = '';
    private dateOfBirth = moment().format('YYYY-MM-DD')
    private companyName = ''
    private workerName = ''
    private isproducers = false;
    private alteredProducers = false;
    private loginTenantId = ''
    private tempShippingOrganizationId = ""
    private repCommitteName = null;
    private alertMessage = 'リクエストに失敗しました。\n'

    @Prop() 
    isShowProducerRegistrationModal!: boolean

    @Prop()
    producerIdParam!: string

    @Prop()
    producerMail!: string

    @Prop()
    isNoyakuNavi!: boolean


    @Watch('isShowProducerRegistrationModal')
    private showProducers() {
        if(!this.pesticidePlanOwner){
            this.getProducers(true)
        }
        if(this.pesticidePlanOwner){
            this.getproducerbyId()
        }
        this.loginTenantId = this.$store.getters.tenantId

    }

    @Watch('isShowProducerRegistrationModal')
    onModalVisibilityChanged(val: boolean) {
        this.$emit('update-inert', val)
    }

    get pesticidePlanProducer() : boolean {
      return this.loginUser.pesticidePlanProducer;
    }

    get pesticidePlanOwner() : boolean {
      return this.loginUser.isPesticidePlan;
    }

    get loginUser(): LoginUser {
         return this.$store.getters.loginUser;
    }

    private getProducers(withHidden: boolean) {
        this.list = null
        this.isLoading = true
        this.$apiClient.doRequest('get', `${this.baseUrl}/producer`).then(res => {
            this.producers = toCamel(res);
            this.producerId = this.producers.pdId
            this.producerName =this.producers.pdName
            this.producerNum = this.producers.pdNo
            this.picName = this.producers.picName
            this.address = this.producers.address
            this.teleNum = this.producers.telephone
            this.updated = this.producers.updated
            if(!this.isNoyakuNavi){
                this.tempShippingOrganizationId = this.producers.shippingOrganizationId
                this.selectedShippingGroupId = this.producers.shippingOrganizationId
            }
            this.isHidden = this.producers.isHidden
            this.mailAddress = this.producers.mailAddress
            this.companyName = this.producers.companyName
            this.workerName = this.producers.workerName
            this.isproducers = this.producers.producerFlag
            this.isDeletable = this.producers.isDeletable

            if(this.producerName == null){
                this.producerName = this.producers.getWorkerNameAndCompanyName[0].companyName
            }
            if(this.picName == null){
                this.picName = this.producers.getWorkerNameAndCompanyName[0].name
            }

            this.shippingGroupList = this.producers.getNameAndCompany

            if( (
                this.selectedShippingGroupId == '' || this.selectedShippingGroupId == null )
             && !this.isNoyakuNavi){

                if(this.shippingGroupList){
                    this.tempShippingOrganizationId = this.shippingGroupList[0].tenantId
                    this.selectedShippingGroupId = this.shippingGroupList[0].tenantId
                }
            }
          this.dateOfBirth = this.producers.dateOfBirth

            if (this.dateOfBirth) {
                const dateObj = new Date(this.dateOfBirth)
                if (!isNaN(dateObj.getTime())) {
                    this.year = String(dateObj.getFullYear())
                    this.month = String(dateObj.getMonth() + 1)
                    this.date = String(dateObj.getDate())
                }
            }else{
                this.year = ''
                this.month = ''
                this.date = ''
            }
        })
        .finally(() => {
            this.isLoading = false
        })
    }

    getproducerbyId(){
        this.$apiClient.doRequest('get', `${this.baseUrl}/${this.producerIdParam}`).then(res => {  
            this.producerId = res.pdId
            this.repCommitteName = res.committeeName
            this.producerName =res.pdName
            this.producerNum = res.pdNo
            this.picName = res.picName
            this.address = res.address
            this.teleNum = res.telephone
            this.dateOfBirth = res.dateOfBirth
            this.mailAddress = this.producerMail
            this.updated = res.updated
            this.isHidden = res.isHidden

            if (this.dateOfBirth) {
                const dateObj = new Date(this.dateOfBirth)
                if (!isNaN(dateObj.getTime())) {
                    this.year = String(dateObj.getFullYear())
                    this.month = String(dateObj.getMonth() + 1)
                    this.date = String(dateObj.getDate())
                }
            }else{
                this.year = ''
                this.month = ''
                this.date = ''
            }
        })
        .finally(() => {
            this.isLoading = false
        })


    }

    private handleSelectChange(flag = true){
        if (this.alteredProducers) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                this.tempShippingOrganizationId = this.selectedShippingGroupId
                return false;
            }
        }
        this.alteredProducers = false
        this.selectedShippingGroupId = this.tempShippingOrganizationId
        const params = {
          shippingOrganizationId: this.selectedShippingGroupId,
          screenName: this.screen,
        }
         this.$apiClient.doRequest('post', `${this.selectScreenManagement}`,params).then(res => {
            if (flag) {
                this.getProducers(true);
            }
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
        })
    }

    private switchDisplay() {
        if (!window.confirm(`${this.producerName}を${ this.isHidden ? '表示状態に戻します' : '非表示にします' }。よろしいですか？`)){
            return
        }
        this.isLoading = true
        this.$apiClient.doRequest('put', `${this.baseUrl}/${this.producerId}/display?is_hidden=${!this.isHidden}&tenant_id=${this.selectedShippingGroupId?this.selectedShippingGroupId:this.loginTenantId}&updated=${this.updated}`).then((res) => {
            if (res.message) {
                window.alert(this.alertMessage + res.message);
                this.$toasted.error('変更に失敗しました。')
                return;
            }
            this.isHidden = !this.isHidden;
            this.$emit('update:isRefresh', true);
            this.$toasted.success(this.isHidden ? `非表示に変更しました。` : `表示に変更しました。`)
            this.getproducerbyId()
        })
        .catch(() => {
            this.$toasted.error('変更に失敗しました。')
        })
        .finally(() => {
            this.isLoading = false
        })
    }

    private cancelEdit() {
        if (this.alteredProducers) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        }
        this.alteredProducers = false
        if(!this.pesticidePlanOwner){
        this.getProducers(true)
        }else{
         this.getproducerbyId()
        }
    }

    private submit(isHiddenUpdate: boolean) {
        const errmsg: string[] = []
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        const yearAsNumber = Number(this.year);
        const monthAsNumber = Number(this.month);
        const dateAsNumber = Number(this.date);
        const dayOfMonth = currentDate.getDate();
        let specificDateError = false;
        if (yearAsNumber !== 0 && this.year && this.year.toString().length !== 4) {
            specificDateError = true;
        } else if(monthAsNumber !== 0 && (this.month && (monthAsNumber < 1 || monthAsNumber > 12))) {
            specificDateError = true;
        } else if(dateAsNumber !== 0 && (this.date && (dateAsNumber < 1 || dateAsNumber > 31))) {
            specificDateError = true;
        } else if (this.year) {
          if (yearAsNumber > currentYear) {
            specificDateError = true;
          } else if (yearAsNumber === currentYear && monthAsNumber > currentMonth){
            specificDateError = true;
          } else if(yearAsNumber === currentYear && monthAsNumber === currentMonth && dateAsNumber > dayOfMonth){
            specificDateError = true;
          }
        } 
        if ((yearAsNumber === 0 || monthAsNumber === 0 || dateAsNumber === 0) && !(yearAsNumber === 0 && monthAsNumber === 0 && dateAsNumber === 0)) {
            specificDateError = true;
        }

        if (this.year && this.month && this.date && errmsg.length === 0) {
            const inputDate = new Date(yearAsNumber, monthAsNumber - 1, dateAsNumber);
            if (inputDate.getFullYear() !== yearAsNumber || 
                inputDate.getMonth() !== (monthAsNumber - 1) ||
                inputDate.getDate() !== dateAsNumber) {
                    specificDateError = true;
            }
        }
        if (specificDateError) {
            errmsg.push("生年月日を確認してぐたさい。");
        }
        // 名前の入力
        
        if(!this.producerName || this.producerName.trim()=== '') {
            errmsg.push("生産者名を入力してください")
        }
        
        if(this.producerName.length > 100) {
            errmsg.push(`生産者名は100文字以内で入力してください（現在は${this.producerName.length}文字）`)
        }

        if(!this.producerNum && this.isNoyakuNavi) {
            errmsg.push("生産者番号を入力してください")
        }

        if(this.producerNum && this.producerNum.length>4) {
            errmsg.push(`生産者番号は４桁以内で入力してください （現在は${this.producerNum.length}桁）`)
        }
        if(!this.picName || this.picName.trim() === '') {
            errmsg.push("責任者を入力してください")
        }

        if(this.picName && this.picName.length>255) {
            errmsg.push(`責任者は255文字以内で入力してください （現在は${this.picName.length}文字）`)
        }

        if(this.address && this.address.length>200) {
            errmsg.push(`住所は200文字以内で入力してください （現在は${this.address.length}文字）`)
        }

        if(!this.teleNum) {
            errmsg.push("電話番号を入力してください")
        }

        if(this.teleNum && this.teleNum.length>15) {
            errmsg.push(`電話番号は15桁以内で入力してください （現在は${this.teleNum.length}桁）`)
        }

        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }
        this.isLoading = true
        const isValidDate = yearAsNumber && monthAsNumber && dateAsNumber;
        const tenantId = this.$store.getters.tenantId
        const params = {
            pdName: this.producerName && this.producerName.trim(),
            picName: this.picName && this.picName.trim(),
            pdNo: this.producerNum,
            address: this.address && this.address.trim(),
            telephone:this.teleNum,
            tenantId: this.selectedShippingGroupId?this.selectedShippingGroupId:this.loginTenantId,
            dateOfBirth: isValidDate ? `${yearAsNumber}-${monthAsNumber.toString().padStart(2, '0')}-${dateAsNumber.toString().padStart(2, '0')}` : null,
            updated: this.updated
        } 
        
        const result = window.confirm("内容を上書きして保存します。よろしいですか。")
            if (!result) {
                this.isLoading = false
                return false;
            }
            this.$apiClient.doRequest("put", `${this.baseUrl}/${this.producerId}`, params).then((res) => {
                if (res.message) {
                    window.alert(this.alertMessage + res.message);
                    this.$toasted.error('変更に失敗しました。')
                    return;
                }
                this.closeModal();
                this.$emit('update:isRefresh', true);
                this.$toasted.success('変更を保存しました。')
            })
            .catch(() => {
                this.$toasted.error('変更に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
            this.alteredProducers = false

    }

    @Emit('inputChanged')
    inputChanged(){
        if(this.alteredProducers==false){
            this.alteredProducers = true
        }
    }

    @Emit('cancel')
    private cancel() {
        this.isShowProducerRegistrationModal = false
    }

    closeModal(){
        if(this.alteredProducers==true){
           const confirm = window.confirm('変更内容を破棄します。よろしいですか？')
            if(confirm){
                this.alteredProducers = false
                this.$emit('update:isShowProducerRegistrationModal', false);
            }
        }else{
            this.$emit('update:isShowProducerRegistrationModal', false);
        }
    }

    deleteProducer(){
        if(this.repCommitteName!=null){
            window.alert(this.repCommitteName + ' 部会の代表者は、削除できません。')
        }
        else{
            const confirm = window.confirm('削除しますか？')
            this.isLoading = true

            if(confirm) {
                this.alteredProducers = false
                this.$apiClient.doRequest('put', `${this.baseUrl}/${this.producerId}/delete?tenant_id=${this.loginTenantId}&updated=${this.updated}`)
                    .then((res) => {
                        if (res.message) {
                            window.alert(this.alertMessage + res.message);
                            this.$toasted.error('削除に失敗しました。')
                            return;
                        }
                        this.$toasted.success('削除しました。')
                        this.closeModal();
                        this.$emit('update:isRefresh', true);
                    })
                    .catch(() => {
                        this.$toasted.error('削除に失敗しました。')
                    }).finally(() => {
                        this.isLoading = false
                    })
            } else {
                this.$toasted.success('削除がキャンセルされました。')
                this.isLoading = false
            }
        }
    }

    get selectedShippingGroupName() {
        const selected = this.shippingGroupList.find(item => item.tenantId === this.selectedShippingGroupId);
        if (selected) {
        const companyDisplay = selected.companyName || selected.name ;
        return `${companyDisplay}`;
       }
    }

    validateTelephoneInput(event: InputEvent) {
        const input = event.data;
        const target = event.target as HTMLInputElement;

        const inputType = event.inputType;

        // Always allow deletions
        if (inputType === 'deleteContentBackward' || inputType === 'deleteContentForward') {
            return;
        }

        // Allow only digits, +, and -
        const isAllowedChar = input ? /^[\d+-]$/.test(input) : true;

        // Prevent if exceeding 15 characters
        const willExceedLength = target.value.length >= 15;

        if (!isAllowedChar || willExceedLength) {
            event.preventDefault();
        }
    }

}